
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ifs-interview-thankyou",
      function () {
        return require("private-next-pages/ifs-interview-thankyou/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ifs-interview-thankyou"])
      });
    }
  